import { Chip } from '@mui/material'
import {
  Datagrid,
  DateField,
  FunctionField,
  List,
  ReferenceField,
  TextField,
  useTranslate,
} from 'react-admin'

const StatusField = ({ record }: { record: any }) => {
  const translate = useTranslate()
  const getStatusColor = (status: string) => {
    switch (status) {
      case 'active':
        return 'success'
      case 'invited':
        return 'warning'
      case 'declined':
        return 'error'
      case 'pending_consent':
        return 'info'
      default:
        return 'default'
    }
  }

  return (
    <Chip
      label={translate(`pos.group_members.status.${record.status}`, {
        _: record.status.replace('_', ' '),
      })}
      color={getStatusColor(record.status)}
      size="small"
    />
  )
}

const ConsentField = ({ record }: { record: any }) => {
  const translate = useTranslate()
  const getConsentColor = (consent: string) => {
    switch (consent) {
      case 'granted':
        return 'success'
      case 'pending':
        return 'warning'
      case 'denied':
        return 'error'
      default:
        return 'default'
    }
  }

  return (
    <Chip
      label={translate(`pos.group_members.consent.${record.consent}`, { _: record.consent })}
      color={getConsentColor(record.consent)}
      size="small"
    />
  )
}

const GroupMemberList = () => {
  const translate = useTranslate()
  return (
    <List>
      <Datagrid>
        <ReferenceField source="group" reference="groups">
          <TextField source="name" />
        </ReferenceField>
        <TextField source="email" />
        <ReferenceField source="user" reference="users" emptyText="-">
          <TextField source="name" />
        </ReferenceField>
        <FunctionField render={(record: any) => <StatusField record={record} />} />
        <FunctionField
          label={translate('pos.group_members.col_consent')}
          render={(record: any) => <ConsentField record={record} />}
        />
        <ReferenceField source="invitedBy" reference="users">
          <TextField source="name" />
        </ReferenceField>
        <DateField source="invitedAt" showTime />
        <DateField source="consentGrantedAt" showTime emptyText="-" />
        <DateField source="joinedAt" showTime emptyText="-" />
      </Datagrid>
    </List>
  )
}

export default GroupMemberList
